import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Appt Components
import ResponsiveGrid from '../../../components/compound/responsiveGrid/ResponsiveGrid.js'
import Box from '../../../components/simple/box/Box.js'
import Divider from '../../../components/simple/divider/Divider.js'
import Text from '../../../components/simple/text/Text.js'

// App widgets

// Shared Components

import { Bar } from 'react-chartjs-2';
import SimpleCounter from '../../../components/compound/simpleCounter/SimpleCounter';

import LocalStorageService from '../../../services/LocalStorageService.js'
import { backgroundColours, borderColours } from '../common/colours.js'

const ClickerReport = props => {
  const navigate = useNavigate();
  const terms = LocalStorageService.get('terms');

  const [clickerByStudent, setclickerByStudent] = useState([]);
  const [clickerByType, setclickerByType] = useState([]);
  const [clickerCount, setclickerCount] = useState([]);
  const [clickerStudentCount, setclickerStudentCount] = useState([]);

  const [clickerSearch, setclickerSearch] = useState([]);
  const [clickerByTypeData, setclickerByTypeData] = useState([]);
  const [clickerStudentOverview, setclickerStudentOverview] = useState([]);

  const [numSuspendedStudents, setSupendedStudents] = useState([]);


  // Incidents by Student Group
   const summary = {
     labels: clickerByType?.map(item => item?.subtype),
     datasets: [
       {
         data: clickerByType?.map(item => item?.count),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };


   const students = {
     labels: clickerStudentOverview?.map(item => `${item?.studentFirstname || ''} ${item?.studentLastname || ''}`),
     datasets: [
       {
         data: clickerStudentOverview?.map(item => item?.count),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };
   

  const printScreen = () => {
    window.print();
  };

  useEffect(() => {
    // Map the API data in props.reportData into the relevant datasets
    if (props?.reportData?.clickerByStudent !== null) {
      setclickerByStudent(props?.reportData?.clickerByStudent);
    }

    if (props?.reportData?.clickerByType !== null) {
      setclickerByType(props?.reportData?.clickerByType);
    }

    if (props?.reportData?.clickerCount !== null) {
      setclickerCount(props?.reportData?.clickerCount);
    }

    if (props?.reportData?.clickerStudentCount !== null) {
      setclickerStudentCount(props?.reportData?.clickerStudentCount);
    }

    if (props?.reportData?.clickerStudentOverview !== null) {
      setclickerStudentOverview(props?.reportData?.clickerStudentOverview);
    }

    if (props?.reportData?.clickerSearch !== null) {
      setclickerSearch(props?.reportData?.clickerSearch);
    }

    

    // let clickerByStudentData = props?.reportData?.clickerByStudent;
    // let clickerMap = {}

  //   for (let row of clickerByStudentData) {
  //     if (!clickerMap[row.subtype]) {
  //       clickerMap[row.subtype] = {
  //         data: [],
  //         lable: [],
  //         title: row.subtype,
  //       };  
  //     }

  //      clickerMap[row.subtype].data.push(

        
  //   }

    

  //   const suspendedStudents = {
  //    labels: numSuspendedStudents?.at(0),
  //    datasets: [
  //      {
  //        data: numSuspendedStudents?.at(1),
  //        backgroundColor: backgroundColours,
  //        borderColor: borderColours,
  //        borderWidth: 1,
  //      },
  //    ],
  //  };
  
  }, [props.reportData]);

  return (
    <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }}>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['50%', '50%'],
            medium: ['50%', '50%'],
            large: ['50%', '50%'],
            xlarge: ['50%', '50%'],
          }}
          gap="small"
          pad="xxsmall"
        >
          <SimpleCounter
            count={
              props?.reportData?.clickerCount?.[0]?.count
                ? String(props.reportData.clickerCount[0].count)
                : '0'
            }
            label="Total Count"
          />
          <SimpleCounter
            count={
              props?.reportData?.clickerStudentCount?.[0]?.count
                ? String(props.reportData.clickerStudentCount[0].count)
                : '0'
            }
            label="Number Students"
          />
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Clicker Summary
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {summary?.length !== 0 ? (
              <Bar
                data={summary}
                height={25}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'quickBehaviour';
                  let value = props?.reportData?.clickerByType?.[_index]?.subtype
                  props.addFilter(key, value);

                  }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>

         <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms?.serviceUser?.charAt(0)?.toUpperCase() + terms?.serviceUser?.slice(1)} Summary
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {students?.length !== 0 ? (
              <Bar
                data={students}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'studentName';
                  let value = props?.reportData?.clickerByStudent?.[_index]?.studentId
                  props.addFilter(key, value);

                  }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>
        
    </Box>
  );
};

export default ClickerReport;
